export enum Language {
	Afar = 'aa',
	Abkhazian = 'ab',
	Avestan = 'ae',
	Afrikaans = 'af',
	Akan = 'ak',
	Amharic = 'am',
	Aragonese = 'an',
	Arabic = 'ar',
	Assamese = 'as',
	Avaric = 'av',
	Aymara = 'ay',
	Azerbaijani = 'az',
	Bashkir = 'ba',
	Belarusian = 'be',
	Bulgarian = 'bg',
	Bislama = 'bi',
	Bambara = 'bm',
	Bengali = 'bn',
	Tibetan = 'bo',
	Breton = 'br',
	Bosnian = 'bs',
	Catalan = 'ca',
	Chechen = 'ce',
	Chamorro = 'ch',
	Corsican = 'co',
	Cree = 'cr',
	Czech = 'cs',
	ChurchSlavic = 'cu',
	Chuvash = 'cv',
	Welsh = 'cy',
	Danish = 'da',
	German = 'de',
	Maldivian = 'dv',
	Dzongkha = 'dz',
	Ewe = 'ee',
	Greek = 'el',
	English = 'en',
	Esperanto = 'eo',
	Spanish = 'es',
	Estonian = 'et',
	Basque = 'eu',
	Persian = 'fa',
	Fulah = 'ff',
	Finnish = 'fi',
	Fijian = 'fj',
	Faroese = 'fo',
	French = 'fr',
	WesternFrisian = 'fy',
	Irish = 'ga',
	Gaelic = 'gd',
	Galician = 'gl',
	Guarani = 'gn',
	Gujarati = 'gu',
	Manx = 'gv',
	Hausa = 'ha',
	Hebrew = 'he',
	Hindi = 'hi',
	HiriMotu = 'ho',
	Croatian = 'hr',
	Haitian = 'ht',
	Hungarian = 'hu',
	Armenian = 'hy',
	Herero = 'hz',
	Interlingua = 'ia',
	Indonesian = 'id',
	Interlingue = 'ie',
	Igbo = 'ig',
	SichuanYi = 'ii',
	Inupiaq = 'ik',
	Ido = 'io',
	Icelandic = 'is',
	Italian = 'it',
	Inuktitut = 'iu',
	Japanese = 'ja',
	Javanese = 'jv',
	Georgian = 'ka',
	Kongo = 'kg',
	Kuanyama = 'kj',
	Kazakh = 'kk',
	Kalaallisut = 'kl',
	CentralKhmer = 'km',
	Kannada = 'kn',
	Korean = 'ko',
	Kanuri = 'kr',
	Kashmiri = 'ks',
	Kurdish = 'ku',
	Komi = 'kv',
	Cornish = 'kw',
	Kirghiz = 'ky',
	Latin = 'la',
	Luxembourgish = 'lb',
	Ganda = 'lg',
	Limburgan = 'li',
	Lingala = 'ln',
	Lao = 'lo',
	Lithuanian = 'lt',
	LubaKatanga = 'lu',
	Latvian = 'lv',
	Malagasy = 'mg',
	Marshallese = 'mh',
	Maori = 'mi',
	Macedonian = 'mk',
	Malayalam = 'ml',
	Mongolian = 'mn',
	Marathi = 'mr',
	Malay = 'ms',
	Maltese = 'mt',
	Burmese = 'my',
	Nauru = 'na',
	Bokmål = 'nb',
	Ndebele = 'nr',
	Nepali = 'ne',
	Ndonga = 'ng',
	Dutch = 'nl',
	Nynorsk = 'nn',
	Norwegian = 'no',
	Navajo = 'nv',
	Chichewa = 'ny',
	Occitan = 'oc',
	Ojibwa = 'oj',
	Oromo = 'om',
	Oriya = 'or',
	Ossetian = 'os',
	Panjabi = 'pa',
	Polish = 'pl',
	Pushto = 'ps',
	Portuguese = 'pt',
	Quechua = 'qu',
	Romansh = 'rm',
	Rundi = 'rn',
	Romanian = 'ro',
	Russian = 'ru',
	Kinyarwanda = 'rw',
	Sanskrit = 'sa',
	Sardinian = 'sc',
	Sindhi = 'sd',
	NorthernSami = 'se',
	Sango = 'sg',
	Sinhala = 'si',
	Slovak = 'sk',
	Slovenian = 'sl',
	Samoan = 'sm',
	Shona = 'sn',
	Somali = 'so',
	Albanian = 'sq',
	Serbian = 'sr',
	Swati = 'ss',
	Sotho = 'st',
	Sundanese = 'su',
	Swedish = 'sv',
	Swahili = 'sw',
	Tamil = 'ta',
	Telugu = 'te',
	Tajik = 'tg',
	Thai = 'th',
	Tigrinya = 'ti',
	Turkmen = 'tk',
	Tagalog = 'tl',
	Tswana = 'tn',
	Tonga = 'to',
	Turkish = 'tr',
	Tsonga = 'ts',
	Tatar = 'tt',
	Twi = 'tw',
	Tahitian = 'ty',
	Uighur = 'ug',
	Ukrainian = 'uk',
	Urdu = 'ur',
	Uzbek = 'uz',
	Venda = 've',
	Vietnamese = 'vi',
	Volapük = 'vo',
	Walloon = 'wa',
	Wolof = 'wo',
	Xhosa = 'xh',
	Yiddish = 'yi',
	Yoruba = 'yo',
	Zhuang = 'za',
	Chinese = 'zh',
	SimplifiedChinese = 'zh-Hans',
	Zulu = 'zu',
	Hawaiian = 'haw',
}

export const LANGUAGE_MAP = {
	aa: 'Afar',
	ab: 'Abkhazian',
	ae: 'Avestan',
	af: 'Afrikaans',
	ak: 'Akan',
	am: 'Amharic',
	an: 'Aragonese',
	ar: 'Arabic',
	as: 'Assamese',
	av: 'Avaric',
	ay: 'Aymara',
	az: 'Azerbaijani',
	ba: 'Bashkir',
	be: 'Belarusian',
	bg: 'Bulgarian',
	bi: 'Bislama',
	bm: 'Bambara',
	bn: 'Bengali',
	bo: 'Tibetan',
	br: 'Breton',
	bs: 'Bosnian',
	ca: 'Catalan',
	ce: 'Chechen',
	ch: 'Chamorro',
	co: 'Corsican',
	cr: 'Cree',
	cs: 'Czech',
	cu: 'Church Slavic',
	cv: 'Chuvash',
	cy: 'Welsh',
	da: 'Danish',
	de: 'German',
	dv: 'Maldivian',
	dz: 'Dzongkha',
	ee: 'Ewe',
	el: 'Greek',
	en: 'English',
	eo: 'Esperanto',
	es: 'Spanish',
	et: 'Estonian',
	eu: 'Basque',
	fa: 'Persian',
	ff: 'Fulah',
	fi: 'Finnish',
	fj: 'Fijian',
	fo: 'Faroese',
	fr: 'French',
	fy: 'Western Frisian',
	ga: 'Irish',
	gd: 'Gaelic',
	gl: 'Galician',
	gn: 'Guarani',
	gu: 'Gujarati',
	gv: 'Manx',
	ha: 'Hausa',
	he: 'Hebrew',
	hi: 'Hindi',
	ho: 'Hiri Motu',
	hr: 'Croatian',
	ht: 'Haitian',
	hu: 'Hungarian',
	hy: 'Armenian',
	hz: 'Herero',
	ia: 'Interlingua',
	id: 'Indonesian',
	ie: 'Interlingue',
	ig: 'Igbo',
	ii: 'Sichuan Yi',
	ik: 'Inupiaq',
	io: 'Ido',
	is: 'Icelandic',
	it: 'Italian',
	iu: 'Inuktitut',
	ja: 'Japanese',
	jv: 'Javanese',
	ka: 'Georgian',
	kg: 'Kongo',
	kj: 'Kuanyama',
	kk: 'Kazakh',
	kl: 'Kalaallisut',
	km: 'Central Khmer',
	kn: 'Kannada',
	ko: 'Korean',
	kr: 'Kanuri',
	ks: 'Kashmiri',
	ku: 'Kurdish',
	kv: 'Komi',
	kw: 'Cornish',
	ky: 'Kirghiz',
	la: 'Latin',
	lb: 'Luxembourgish',
	lg: 'Ganda',
	li: 'Limburgan',
	ln: 'Lingala',
	lo: 'Lao',
	lt: 'Lithuanian',
	lu: 'Luba-Katanga',
	lv: 'Latvian',
	mg: 'Malagasy',
	mh: 'Marshallese',
	mi: 'Maori',
	mk: 'Macedonian',
	ml: 'Malayalam',
	mn: 'Mongolian',
	mr: 'Marathi',
	ms: 'Malay',
	mt: 'Maltese',
	my: 'Burmese',
	na: 'Nauru',
	nb: 'Bokmål',
	ne: 'Nepali',
	ng: 'Ndonga',
	nl: 'Dutch',
	nn: 'Nynorsk',
	no: 'Norwegian',
	nr: 'Ndebele',
	nv: 'Navajo',
	ny: 'Chichewa',
	oc: 'Occitan',
	oj: 'Ojibwa',
	om: 'Oromo',
	or: 'Oriya',
	os: 'Ossetian',
	pa: 'Panjabi',
	pl: 'Polish',
	ps: 'Pushto',
	pt: 'Portuguese',
	qu: 'Quechua',
	rm: 'Romansh',
	rn: 'Rundi',
	ro: 'Romanian',
	ru: 'Russian',
	rw: 'Kinyarwanda',
	sa: 'Sanskrit',
	sc: 'Sardinian',
	sd: 'Sindhi',
	se: 'Northern Sami',
	sg: 'Sango',
	si: 'Sinhala',
	sk: 'Slovak',
	sl: 'Slovenian',
	sm: 'Samoan',
	sn: 'Shona',
	so: 'Somali',
	sq: 'Albanian',
	sr: 'Serbian',
	ss: 'Swati',
	st: 'Sotho',
	su: 'Sundanese',
	sv: 'Swedish',
	sw: 'Swahili',
	ta: 'Tamil',
	te: 'Telugu',
	tg: 'Tajik',
	th: 'Thai',
	ti: 'Tigrinya',
	tk: 'Turkmen',
	tl: 'Tagalog',
	tn: 'Tswana',
	to: 'Tonga',
	tr: 'Turkish',
	ts: 'Tsonga',
	tt: 'Tatar',
	tw: 'Twi',
	ty: 'Tahitian',
	ug: 'Uighur',
	uk: 'Ukrainian',
	ur: 'Urdu',
	uz: 'Uzbek',
	ve: 'Venda',
	vi: 'Vietnamese',
	vo: 'Volapük',
	wa: 'Walloon',
	wo: 'Wolof',
	xh: 'Xhosa',
	yi: 'Yiddish',
	yo: 'Yoruba',
	za: 'Zhuang',
	zh: 'Chinese',
	'zh-Hans': 'Simplified Chinese',
	zu: 'Zulu',
	haw: 'Hawaiian',
};

// export a type for Language
export const REVERSED_LANGUAGE_MAP = Object.entries(LANGUAGE_MAP).reduce((acc, [key, value]) => {
	acc[value] = key;
	return acc;
}, {});
